<template>
  <div class="wrap">
    <div class="content">
      <template v-if="type === 'loading'">
        <div class="icon loading"></div>
        <div class="text">{{ $t('loginning') }}</div>
      </template>
      <template v-else-if="type === 'success'">
        <div class="icon success"></div>
        <div class="text">{{ $t('login_success_2') }}</div>
      </template>
      <template v-else-if="type === 'fail'">
        <div class="icon fail"></div>
        <div class="text">{{ $t('login_fail_2') }}</div>
      </template>
    </div>
    <div v-if="type === 'fail'" class="btns">
      <Button type="warning" @click="reLogin">{{ $t('try_again') }} </Button>
    </div>
  </div>
</template>

<script>
import { sendLogin } from '../utils/Qtbridge'
import { socialLogin } from '@/api'
export default {
  name: 'Result',
  data () {
    return {
      type: 'loading',
      urlParams: JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
    }
  },
  created () {
    this.login()
  },
  methods: {
    login () {
      // socialLogin({"gameId":30001,"deviceId":"nnjknjkasdnjkasdnjkqw","bindType":23,"accessToken":"FP|NjNiMjFmZTQuMmZkNjIxYzhmLjQ1NzE3ODAyNThlNzlkMTJmZjgwZGRmYzBjMmNjYzBkLjYyODM5Nzdm","deviceUuid":"4398b1da-6f6c-40be-88a9-5bb64998e071","bindInfo":{"id":"12841000079","name":"44***87@qq.com","email":""}})
      const data = this.$route.params.loginData || {}
      this.$utils.log('pc_web_loging', {
        login_method: data.type + (data.mode ? `_${data.mode}` : '')
      })
      if (typeof window.qt !== 'undefined') {
        this.loginWithMicroTerminal(data)
      } else if (this.urlParams.refer) {
        this.loginWithWebsite(data)
      }
    },
    // 网页登录
    loginWithWebsite (data) {
      const refer = decodeURIComponent(this.urlParams.refer)
      // 是否需要游戏数据 ng - need game 
      if (!this.urlParams.ng) {
        window.location.href = `${refer}?data=${
          {
            name: data.name,
            id: data.id,
            token: data.token
          }
        }`
      } else {
        const params = {
          gameId: this.urlParams.gid,
          deviceId: 'fpoauth' + this.$utils.randomString(25),
          bindType: this.$ENUM.SOCIAL_CODE_MAP[data.type],
          accessToken: data.token,
          deviceUuid: this.$utils.getUuid(),
          bindInfo: {
            id: data.id,
            name: data.name,
            email: data.email || ''
          }
        }
        socialLogin(params).then(res => {
          this.type = 'success'
          window.location.href = `${refer}?${this.urlParams.ng}=${this.$utils.string10to62(res.fpid)}`
        }).catch(err => {
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
          this.type = 'fail'
          setTimeout(() => {
            window.location.href = `${refer}`
          }, 2000);
        })
      }
    },
    // 微端登录
    loginWithMicroTerminal (data) {
      const params = {
        ...data,
        id: data.id.toString()
      }
      sendLogin(params)
        .then(() => this.type = 'success')
        .catch(err => {
          this.type = 'fail'
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
        })
    },
    reLogin () {
      this.$router.replace({ name: 'Login2' })
    }
  }
}
</script>

<style lang='less' scoped >
.r-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_success.png) center center no-repeat;
    background-size: 100% 100%;
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
  }
}
.wrap {
  height: 100%;
  padding: 0 32px 20px;
  display: flex;
  flex-direction: column;
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_fail.png) center center no-repeat;
    background-size: 100% 100%;
    &.success { background-image: url(~@img/icon_success.png); }
    &.fail { background-image: url(~@img/icon_fail.png); }
    &.loading {
      background-image: url(~@img/icon_loading.png);
      filter: contrast(0.5);
      animation: infiniteRotate linear 2s infinite;
    }
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
  }
}
@keyframes infiniteRotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
